import React, { useEffect, useState, useMemo } from 'react';
import { Card } from 'antd';
import { useTranslation } from 'react-i18next';
import { AuditLogViewer, createAuthApi } from '@zero/auth-admin-ui';
import { useGridPageSize } from '../../hooks/useGridPageSize.js';

export function AuditPage({ axios }) {
  const api = useMemo(() => createAuthApi(axios), [axios]);
  const { t } = useTranslation();
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useGridPageSize('audit', 25);

  useEffect(() => {
    setLoading(true);
    api.listAuditLog({ offset: 0, limit: 200 })
      .then((r) => setEntries(r.data?.Data?.Items ?? []))
      .finally(() => setLoading(false));
  }, [api]);

  return <AuditLogViewer entries={entries} loading={loading} scrollY="calc(100vh - 130px)" pageSize={pageSize} onPageSizeChange={setPageSize} />;
}
